import React from 'react';
import RestSelect from './RestSelect';
import { trainingTargetGroupCRUD } from '../../http/CRUD';

const TrainingTargetGroupSelect = ({ programId, ...props }) => {
    const query = programId ? {
        filter: {
            programId: { operand1: programId, operator: 'equals' }
        }
    } : {};

    return (
        <RestSelect
            restApi={trainingTargetGroupCRUD}
            optionValueKey="id"
            optionLabelKey="name"
            getOptionLabel={(option) => option.code ? `${option.code} - ${option.name}` : option.name}
            query={query}
            {...props}
        />
    );
};

export default TrainingTargetGroupSelect;
